import request from '@/utils/request'

export function getWeekData(data) {
  return request({
    url: 'api/v1/user_remain/getWeekData',
    method: 'post',
    data: data
  })
}

export function getWeekCountryData(data) {
  return request({
    url: 'api/v1/user_remain/getWeekCountryData',
    method: 'post',
    data: data
  })
}

